/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
Module voor sihwlog
 */

import {Sihwlog} from "./sihwlog";
import {NgModule} from "@angular/core";
import {LocalconfigModule} from "../localconfig/localconfig.module";

@NgModule({
    declarations: [],
    imports: [
        LocalconfigModule
    ],
    providers: [
        Sihwlog
    ]
}) export class SihwlogModule{}
